import { hexToRgbA } from '@/helper/Color';
import { useThemeColor } from '@/hooks/useThemeColor';
import { StyleSheet, View } from 'react-native';

function getGradientStyle ({ position, size, from, to }) {

    switch (position) {
        case 'top':
            return {
                ...styles.gradientTop,
                height: size,
                background: `linear-gradient(to bottom, ${from}, ${to})`,

            };

        case 'bottom':
            return {
                ...styles.gradientBottom,
                height: size,
                background: `linear-gradient(to top, ${from}, ${to})`,

            };

        case 'left':
            return {
                ...styles.gradientLeft,
                width: size,
                background: `linear-gradient(to right, ${from}, ${to})`,
            };

        case 'right':
            
            return {
                ...styles.gradientRight,
                width: size,
                background: `linear-gradient(to left, ${from}, ${to})`,
            };

        default:
            return {
                ...styles.gradientBottom,
                height: size,
                background: `linear-gradient(to top, ${from}, ${to})`,
            };
    }

};

const Fader = (props) => {

    const { 
        tintColor = '#000000', 
        position = 'bottom',
        size = 100,
        style = {},
        visible = true
    } = props || {};

    const parsedTintColor = useThemeColor(tintColor, 'background');

    const gradientStyle = getGradientStyle({position, size, from: hexToRgbA(parsedTintColor, 1), to: hexToRgbA(parsedTintColor, 0)})

    if (!visible) {
        return <></>;
    }

    return <View pointerEvents={'box-none'} style={[styles.container, gradientStyle, style]} />;
};

const styles = StyleSheet.create({
    container: {
        position: 'absolute',
        zIndex: 100,
    },
    gradientTop: {
        top: 0,
        left: 0,
        right: 0,
        height: 100,
    },
    gradientBottom: {
        bottom: 0,
        left: 0,
        right: 0,
        height: 100,
        position: 'absolute',
    },
    gradientLeft: {
        top: 0,
        bottom: 0,
        left: 0,
        width: 100,
        position: 'absolute',
    },
    gradientRight: {
        top: 0,
        bottom: 0,
        right: 0,
        width: 100,
        position: 'absolute',
    },
});

export default Fader;